import { useFeatureFlagEnabled, useFeatureFlagVariantKey } from 'posthog-js/react'

import type { PostHogFeatureFlag } from './posthogFeatureFlags'

export function usePostHogFeatureFlag(key: PostHogFeatureFlag): boolean {
  return useFeatureFlagEnabled(key) ?? false
}

export function usePostHogFeatureFlagVariant(key: PostHogFeatureFlag): string | boolean | undefined {
  return useFeatureFlagVariantKey(key)
}
